//
// Copyright (C) 2013 - present Instructure, Inc.
//
// This file is part of Canvas.
//
// Canvas is free software: you can redistribute it and/or modify it under
// the terms of the GNU Affero General Public License as published by the Free
// Software Foundation, version 3 of the License.
//
// Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
// WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
// A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
// details.
//
// You should have received a copy of the GNU Affero General Public License along
// with this program. If not, see <http://www.gnu.org/licenses/>.

import $ from 'jquery'
import {some} from 'es-toolkit/compat'
import {useScope as createI18nScope} from '@canvas/i18n'
import DialogFormView from '@canvas/forms/backbone/views/DialogFormView'
import GroupCategoryCloneView from './GroupCategoryCloneView'
import template from '../../jst/randomlyAssignMembers.handlebars'
import wrapper from '@canvas/forms/jst/EmptyDialogFormWrapper.handlebars'
import groupHasSubmissions from '../../groupHasSubmissions'

const I18n = createI18nScope('groups')

const DEFAULT_DIALOG_HEIGHT = 260
const DIALOG_EXPANDED_HEIGHT = 330

export default class RandomlyAssignMembersView extends DialogFormView {
  static initClass() {
    this.prototype.defaults = {
      // @ts-expect-error - Legacy Backbone typing
      title: I18n.t('randomly_assigning_members', 'Randomly Assigning Students'),
      // @ts-expect-error - Legacy Backbone typing
      width: 450,
      // @ts-expect-error - Legacy Backbone typing
      height: DEFAULT_DIALOG_HEIGHT,
    }

    // @ts-expect-error - Backbone View property
    this.prototype.template = template

    this.prototype.wrapperTemplate = wrapper

    this.prototype.className = 'form-dialog'

    // @ts-expect-error - Backbone View property
    this.prototype.events = {
      'click .dialog_closer': 'close',
      'click .randomly-assign-members-confirm': 'randomlyAssignMembers',
      'change input[name=group_by_section]': 'toggleSectionInfo',
    }

    // @ts-expect-error - Backbone View property
    this.prototype.els = {'input[name=group_by_section]': '$group_by_section'}
  }

  openAgain() {
    // @ts-expect-error - Legacy Backbone typing
    super.openAgain(...arguments)
    // @ts-expect-error - Backbone View property
    const groups = this.model.groups().models
    if (some(groups, group => group.usersCount() > 0 || !!group.get('max_membership'))) {
      return this.disableCheckbox(
        // @ts-expect-error - Backbone View property
        this.$group_by_section,
        I18n.t('Cannot restrict by section unless groups are empty and not limited in size'),
      )
      // @ts-expect-error - Backbone View property
    } else if (ENV.student_section_count && ENV.student_section_count > groups.length) {
      return this.disableCheckbox(
        // @ts-expect-error - Backbone View property
        this.$group_by_section,
        I18n.t('Must have at least 1 group per section'),
      )
    } else {
      // @ts-expect-error - Backbone View property
      return this.enableCheckbox(this.$group_by_section)
    }
  }

  // @ts-expect-error - Legacy Backbone typing
  randomlyAssignMembers(e) {
    e.preventDefault()
    e.stopPropagation()
    this.close()

    let groupHasSubmission = false
    // @ts-expect-error - Backbone View property
    for (const group of this.model.groups().models) {
      if (groupHasSubmissions(group)) {
        groupHasSubmission = true
        break
      }
    }
    if (groupHasSubmission) {
      // @ts-expect-error - Backbone View property
      this.cloneCategoryView = new GroupCategoryCloneView({
        // @ts-expect-error - Backbone View property
        model: this.model,
        openedFromCaution: true,
      })
      // @ts-expect-error - Backbone View property
      this.cloneCategoryView.open()
      // @ts-expect-error - Backbone View property
      return this.cloneCategoryView.on('close', () => {
        // @ts-expect-error - Backbone View property
        if (this.cloneCategoryView.cloneSuccess) {
          return window.location.reload()
          // @ts-expect-error - Backbone View property
        } else if (this.cloneCategoryView.changeGroups) {
          // @ts-expect-error - Backbone View property
          return this.model.assignUnassignedMembers()
        }
      })
    } else {
      // @ts-expect-error - Backbone View property
      return this.model.assignUnassignedMembers(this.getFormData().group_by_section === '1')
    }
  }

  // @ts-expect-error - Legacy Backbone typing
  toggleSectionInfo(e) {
    // @ts-expect-error - Backbone View property
    const $infoBox = this.$('#group-by-section-info')
    if (e.target.checked) {
      $infoBox.show()
      // Increase dialog height to accommodate the info box
      // @ts-expect-error - Backbone View property
      this.$el.dialog('option', 'height', DIALOG_EXPANDED_HEIGHT)
    } else {
      $infoBox.hide()
      // Reset dialog height to original size
      // @ts-expect-error - Backbone View property
      this.$el.dialog('option', 'height', DEFAULT_DIALOG_HEIGHT)
    }
  }

  // @ts-expect-error - Legacy Backbone typing
  disableCheckbox(box, message) {
    // shamelessly copypasted from assignments/EditView
    box
      .prop('checked', false)
      .prop('disabled', true)
      .parent()
      .attr('data-tooltip', 'top')
      .data('tooltip', {disabled: false})
      .attr('title', message)
    return this.checkboxAccessibleAdvisory(box).text(message)
  }

  // @ts-expect-error - Legacy Backbone typing
  enableCheckbox(box) {
    if (box.prop('disabled')) {
      box
        .removeProp('disabled')
        .parent()
        .timeoutTooltip()
        .timeoutTooltip('disable')
        .removeAttr('data-tooltip')
        .removeAttr('title')
      return this.checkboxAccessibleAdvisory(box).text('')
    }
  }

  // @ts-expect-error - Legacy Backbone typing
  checkboxAccessibleAdvisory(box) {
    const label = box.parent()
    let advisory = label.find('span.screenreader-only.accessible_label')
    if (!advisory.length)
      advisory = $('<span class="screenreader-only accessible_label"></span>').appendTo(label)
    return advisory
  }
}
RandomlyAssignMembersView.initClass()
